import {
  taxYearColumnDefinition,
  companyCodeColumnDefinition,
  tradingPartnerColumnDefinition,
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  slAccountColumnDefinition,
  bookTypeColumnDefinition,
  accountColumnDefinition,
  currencyColumnDefinition,
  netAmountColumnDefinition,
} from '../columnDefinitions';

export const baseSlJournalColumnDefs = [
  { ...taxYearColumnDefinition, field: 'taxYear' },
  { ...companyCodeColumnDefinition, field: 'companyCode' },
  { ...tradingPartnerColumnDefinition, field: 'tradingPartner' },
  { ...countryCodeColumnDefinition, field: 'countryCode' },
  { ...countryTaxTypeColumnDefinition, field: 'countryTaxType' },
  { ...slAccountColumnDefinition, field: 'slAccount' },
  { ...bookTypeColumnDefinition, field: 'bookType' },
  { ...accountColumnDefinition, field: 'teAdjDescription' },
  { ...currencyColumnDefinition, field: 'currencyCode' },
  { ...netAmountColumnDefinition },
];
